import { AnyAction, ThunkAction } from "@reduxjs/toolkit";
import { SBUBUMapModel } from "../../models/SBUBUMapModel";
import SBUBUMapService from "../../services/SBUBUMapService";
import SBUBUMapSlice from "../slices/SBUBUMapSlice";
import { RootState } from "../store";

export const Actions = SBUBUMapSlice.actions;

export const fetchSBUBUMaps = (): ThunkAction<
  void,
  RootState,
  unknown,
  AnyAction
> => {
  return async (dispatch) => {
    dispatch(Actions.setIsSBUBUMapsFetching(true));
    const response: SBUBUMapModel[] = await SBUBUMapService.getSBUBUMaps();
    dispatch(Actions.setSBUBUMap(response));
    dispatch(Actions.setIsSBUBUMapsFetching(false));
  };
};
